import _ from 'underscore';

export const defaultPhoneSchema = [
  {
    key: 'US',
    label: _TL_('United States'),
    countryCode: '+1',
    formats: [
      '(###) ###-####',
    ],
  },
  {
    key: 'CN',
    label: _TL_('China'),
    countryCode: '+86',
    formats: [
      '### #### ####',
    ],
  },
  {
    key: 'UK',
    label: _TL_('United Kingdom'),
    countryCode: '+44',
    formats: [
      '###-###-####',
    ],
    disabled: true,
  },
];
export const usPhoneSchema = _.where(defaultPhoneSchema, { key: 'US' });

export const getPhoneNumberError = (errors, i18n) => {
  if (errors && errors.required) {
    return [i18n.getString(_TL_('Phone number is required.'))];
  }
  if (errors && errors.maxLength) {
    return [i18n.getString(_TL_('Phone number exceeds the maximum allowed length.'))];
  }
  if (errors && errors.pattern) {
    return [i18n.getString(_TL_('Enter a valid phone number.'))];
  }
  return _.values(errors);
};

export const formatPhoneNumber = (input = '', format = '') => {
  let i = 0;
  let j = 0;

  const m = input.length;
  const n = format.length;
  const chars = [];

  while (i < m && j < n) {
    if (input[i] === format[j]) {
      chars.push(input[i]);
      i += 1;
      j += 1;
    } else if (input[i] < '0' || input[i] > '9') {
      i += 1;
    } else if (format[j] === '#') {
      chars.push(input[i]);
      i += 1;
      j += 1;
    } else {
      chars.push(format[j]);
      j += 1;
    }
  }

  while (i < m) {
    chars.push(input[i]);
    i += 1;
  }

  return chars.join('');
};
